const pastEvents = [
    {
        image_path: "../images/Past_Events/self_care_packages.jpg",
        title: "Calgary Women's Emergency Shelter Self-Care Packages",
        description: "To celebrate & support local women on International Women's Day, HHER created 20 self-care packages for the Calgary Women's Emergency Shelter.\nEach package contains essential self-care items to promote the wellbeing of women & children seeking a safe haven from domestic abuse.",
        insta_link: "https://www.instagram.com/p/DG6aMnxS_2R/?img_index=1"
    },
    {
        image_path: "../images/Past_Events/origami_flowers.jpg",
        title: "Origami Flowers For Patients",
        description: "HHER members and volunteers handcrafted origami flower bouquets for patients at the hospital.\nThese flowers not only bring joy to patients but also remind them that they are cared for and supported.",
        insta_link: "https://www.instagram.com/p/DG6aMnxS_2R/?img_index=1"
    },
    {
        image_path: "../images/Past_Events/self_care_kits.jpg",
        title: "Self Care Kits",
        description: "HHER collaborated with three organizations, Girls Who Like To Do Things, The Knitting Network and the Origami Aid Club to create and donate 20 self-care kits to Making Changes for teens in need. Making Changes provides resources and support to women and teens.",
        insta_link: "https://www.instagram.com/p/DG6aMnxS_2R/?img_index=1"
    }
]

export default pastEvents;